import React from 'react';
import axios from 'axios';
import { getReasonPhrase } from 'http-status-codes';
import { Container, Stack, Typography } from '@mui/material';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { useMutation } from 'react-query';
import API, { useCsrfToken } from '@wheeebo/polaris-api';
function ErrorContent({ code, errorId }) {
    return (React.createElement(Container, { component: "main" },
        React.createElement(Stack, { sx: { width: '100%', display: 'flex', alignItems: 'center' } },
            code ? (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "h1" }, code),
                React.createElement(Typography, { variant: "h6" }, getReasonPhrase(code)))) : (React.createElement(Typography, { variant: "h6" }, "Something went wrong.")),
            errorId ? React.createElement(Typography, { variant: "body2" },
                "Error ID: ",
                errorId) : null)));
}
function ErrorBoundary() {
    const error = useRouteError();
    const { csrfToken } = useCsrfToken();
    const { mutate: emitPageRenderingErrorEvent } = useMutation((event) => API.Track.emitPageRenderingErrorEvent(csrfToken, event));
    React.useEffect(() => {
        if (!error) {
            return;
        }
        emitPageRenderingErrorEvent({
            path: location.pathname,
            search: location.search,
            hash: location.hash,
            error: error.toString(),
        });
    }, [emitPageRenderingErrorEvent, error]);
    if (isRouteErrorResponse(error)) {
        return React.createElement(ErrorContent, { code: error.status });
    }
    else if (axios.isAxiosError(error) && error.response) {
        return React.createElement(ErrorContent, { code: error.response.status, errorId: error.response.data?.id });
    }
    return React.createElement(ErrorContent, null);
}
export default ErrorBoundary;
